<template>

<div class="flex-container">
  <template
    v-for="(deptTaskTypes, departmentId) in value"
  >
    <div
      v-if="isDepDisplayed(deptTaskTypes)"
      class="department-box"
      :key="'ttSel' + departmentId"
      :style="getDepartmentStyle(departmentId)"
    >
      <div class="flexrow department-name">
        <h2 class="flexrow-item">
          {{ departmentMap.get(departmentId)?.name || '---' }}
        </h2>
        <x-icon
          v-if="project"
          @click="onXClick(departmentId, deptTaskTypes)" 
          class="flexrow-item"
          size="0.8x"
        />
      </div>
      <div
        v-if="episodeMode && !prioMode"
        class="flexrow ep-name-line"
      >
        <a
          v-for="ep of episodes"
          :key="departmentId + ep.id"
          class="flexrow-item ep-name"
        >
          {{ ep.name || '---' }}
        </a>
      </div>
      <template 
        v-for="(taskType, ttind) in deptTaskTypes"
      >
        <div
          v-if="!prioMode || !project || (prioMode && project && taskType.id in selected)"
          class="flexrow line"
          :key="taskType.id"
          @mouseover="onMouseover(taskType.id)"
          @mouseleave="onMouseleave(taskType.id)"
        >
          <div 
            v-if="!(prioMode || editMode)"
            class='all-checks flexrow flexrow-item'
          >
            <div 
              v-show="episodeMode"
              class='episode-checks flexrow flexrow-item'
            >
              <checkbox
                v-for="ep of episodes"
                :key="taskType.id + ep.id"
                class="flexrow-item check title"
                :ref="taskType.id + ep.id"
                :toggle="false"
                :checked="selected[taskType.id]?.includes(ep.id)"
                :disabled="blocked.includes(taskType.id)"
                label=""
                @change="(checked) => {
                  if (checked) {
                    $emit('create', taskType.id, ep.id)
                  } else {
                    $emit('delete', taskType.id, ep.id)
                  }
                }"

              />
            </div>
            <checkbox
              class="flexrow-item check title"
              :ref="taskType.id"
              :toggle="false"
              :label="taskType.name || '---'"
              :checked="selected && taskType.id in selected"
              :disabled="blocked.includes(taskType.id)"
              @change="(checked) => {
                if (checked) {
                  $emit('add', taskType.id)
                } else {
                  $emit('remove', taskType.id)
                }
              }"
            />
          </div>
          <template v-if="editMode || prioMode">
            <a
              v-if="prioMode || editMode"
              :class="{
                'flexrow-item': true,
                title: true,
                mouseovered: mouseovered === taskType.id,
                blocked: blocked.includes(taskType.id),
                changed: taskType.id in changes
              }"
              @click="onLineClicked(departmentId, ttind)"
            >
              {{ taskType.name || '---' }}
            </a>
            <div
              v-if="prioMode"
              class="flexrow-item flexrow"
            >
              <a
                v-if="taskType.id in changes"
                class="flexrow-item cross"
                @click="revertChange(taskType, ttind)"
              >X</a>
              <input
                :class="{
                  'flexrow-item': true,
                  input: true,
                  mouseovered: mouseovered === taskType.id,
                  changed: taskType.id in changes
                }"
                :value="priority(taskType)"
                @change="event => onLineClicked(departmentId, ttind, event.target.value)"
              />
            </div>
            <div
              v-else-if="editMode && mouseovered === taskType.id"
              class="flexrow-item flexrow action-cont"
            >
              <edit-icon
                class="flexrow-item action-icon"
                @click="$emit('edit-clicked', taskType)"
              />
              <trash-icon
                class="flexrow-item action-icon"
                @click="$emit('delete-clicked', taskType)"
              />
            </div>
            <a
              v-else
              class="flexrow-item prio-number"
              :title="$t('task_types.fields.priority') + ': ' + priority(taskType)"
              :key="'ttSelP' + departmentId + taskType.id + priority(taskType)"
            >
              {{ priority(taskType) }}
            </a>
          </template>
        </div>
      </template>
    </div>
  </template>
</div>

</template>

<script>
import { mapGetters } from 'vuex'
import { TrashIcon, EditIcon, XIcon } from 'vue-feather-icons'
import colors from '@/lib/colors'
import Checkbox from '@/components/widgets/Checkbox'

export default {
  name: 'task-type-checklist',

  components: {
    TrashIcon,
    EditIcon,
    XIcon,
    Checkbox,
  },

  data () {
    return {
      selection: {},
      changes: {},
      maxPrio: 1,
      mouseovered: null
    }
  },

  props: {
    value: {
      default: () => {},
      type: Object
    },
    selected: {
      default: () => {},
      type: Object
    },
    blocked: {
      default: () => [],
      type: Array
    },
    episodes: {
      default : () => [],
      type: Array
    },
    episodeMode: {
      default: false,
      type: Boolean
    },
    editMode: {
      default: false,
      type: Boolean
    },
    prioMode: {
      default: false,
      type: Boolean
    },
    nextPrio: {
      default: 1,
      type: Number
    },
    project: {
      default: false,
      type: Boolean
    }
  },

  methods: {
    onDebugClick () {
      console.log(this.selected)
    },

    isDepDisplayed (typeList) {
      if (!this.prioMode || !this.project) { return true }
      for (const tt of typeList) {
        if (tt.id in this.selected) { return true }
      }
      return false
    },

    onXClick(depId, types) {
      const name = this.departmentMap.get(depId)?.name
      this.$emit('remove-dep', name || "unknown", types)
    },

    getDepartmentStyle (departmentId) {
      const res = {
        width: this.episodeMode && !this.prioMode ? (this.episodes.length + 18) + 'em' : '18em'
      }
      const department = this.departmentMap.get(departmentId)
      if (department) {
        res['background-color'] = colors.hexToRGBa(department.color, 0.3),
        res.color = this.isDarkTheme ? 'white' : 'black'
      }
      return res
    },

    onMouseover (typeId) {
      this.mouseovered = typeId
    },

    onMouseleave (typeId) {
      if (this.mouseovered === typeId) {
        this.mouseovered = null
      }
    },

    displayedPrio (taskType) {
      if (this.prioMode && this.mouseovered === taskType.id) {
        return this.nextPrio
      } else {
        return this.priority(taskType)
      }
    },

    revertChange (taskType, ttind) {
      const depid = taskType.department_id
      const prio = this.changes[taskType.id]?.former
      if (!prio) { return }
      for (const dep of Object.values(this.value)) {
        if (dep.find(tt => this.priority(tt) === prio)) { return }
      }
      const workcopy = { ...this.value }
      const item = workcopy[depid][ttind]
      if (this.project) {
        item.localPriority = prio
      } else {
        item.priority = prio
      }
      delete this.changes[taskType.id]
      if (prio >= this.maxPrio) {
        Object.values(this.value).forEach(dep => {
          dep.forEach(tt => {
            const prio = this.priority(tt)
            if (this.maxPrio <= prio) {
              this.maxPrio = Number(prio + 1)
            }
          })
        })
      }
      this.$emit('input', workcopy, Object.values(this.changes))
      this.$emit('priority-change')
    },

    addChange (taskType, prioArg, workcopy) {
      const newPrio = Number(prioArg)
      Object.values(workcopy).forEach(dep => {
        const found = dep.find(tt => this.priority(tt) === newPrio)
        if (found) { this.addChange(found, this.maxPrio, workcopy) }
      })
      if (newPrio >= this.maxPrio) { this.maxPrio = newPrio + 1 }
      this.changes[taskType.id] = {
        id: taskType.id,
        name: taskType.name || '---',
        priority: newPrio,
        former: this.project ? this.priority(taskType) : taskType.priority,
        projectId: this.currentProduction.id,
        taskTypeId: taskType.id
      }
      if (this.project) {
        taskType.localPriority = newPrio
      } else {
        taskType.priority = newPrio
      }
      this.$emit('input', workcopy, Object.values(this.changes))
    },

    onLineClicked (depId, ttInd, newPrio = this.nextPrio) {
      if (this.prioMode) {
        const newVal = { ...this.value }
        const item = newVal[depId][ttInd]
        const prio = Number(newPrio)
        this.addChange(item, prio, newVal)
        this.$emit('priority-change')
      }
    },

    priority (taskType) {
      if (!this.project) { return taskType.priority }
      return taskType.localPriority ? taskType.localPriority : this.getTaskTypePriority(taskType.id)
    },

    setCheckState (taskTypeId, state, episodeId = '') {
      // called externally
      this.$refs[taskTypeId + episodeId][0].setState(state)
    }
  },

  computed: {
    ...mapGetters([
      'departmentMap',
      'getTaskTypePriority',
      'currentProduction',
      'isDarkTheme'
    ])
  },

  mounted () {
    Object.values(this.value).forEach(dep => {
      dep.forEach(tt => {
        const prio = this.priority(tt)
        if (this.maxPrio <= prio) {
          this.maxPrio = Number(prio + 1)
        }
      })
    })
  },

  watch: {
    prioMode () {
      if (this.prioMode) {
        this.changes = {}
        Object.values(this.value).forEach(dep => {
          dep.forEach(tt => {
            const prio = this.priority(tt)
            if (this.maxPrio <= prio) {
              this.maxPrio = Number(prio + 1)
            }
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-weight: bold;
  font-size: 115%;
  margin: 15px 0 2px 0;
  border: none;
}

.line {
  margin-bottom: 1px;
  height: 21px;
  justify-content: space-between;
}

.ep-name-line {
  justify-content: start;
  height: 50px;
  margin-bottom: -18px;
  overflow: hidden;
}

.ep-name {
  rotate: -90deg;
  margin-right: 3pt;
}

.episode-checks {
  margin-top: -8px;
  margin-right: 8px;
}

.title {
  font-size: 11pt;
  font-weight: 400;
  margin: 0;
  text-overflow: hidden;
  text-wrap: nowrap;
  color: var(--text);
}

:deep(.title span) {
  font-weight: 400;
}

.mouseovered {
  color: rgb(50, 190, 255);
}
.blocked {
  color: gray;
}
.changed {
  color: rgb(255, 123, 0);
}


a {
  max-width: 17px;
}

.input {
  height: 21px;
  width: 4em;
  padding: 0 2px 0 2px;
}

.cross {
  padding: 2px;
  font-size: 8pt;
  width: 10px;
  margin: 0;
}

.department-box {
  padding: 10px;
  margin-bottom: 8px;
  margin-right: 8px;
}

.flex-container {
  flex-wrap: wrap;
  display: flex;
}

.action-cont {
  height: 21px;
}

.action-icon {
  scale: 70%;
  margin: 0;
  color: rgb(50, 190, 255);
}

.dark {
  .action-icon {
    color: cyan;
  }
  .mouseovered {
    color: cyan;
  }
  .blocked {
    color: gray;
  }
  .changed {
    color: orange;
  }
}

.department-name {
  justify-content: space-between;
  border-bottom: 1px var(--text) solid;
  margin-bottom: 8px;
}
</style>
